// frontend/src/pages/AuditLogs.jsx
import { useState, useEffect } from 'react';
import api from '../services/api';

export default function AuditLogs() {
  const today = new Date().toISOString().split('T')[0]; // Formato YYYY-MM-DD

  const [logs, setLogs] = useState([]);
  const [filters, setFilters] = useState({
    actionType: '',
    dateFrom: today, // Data de hoje como padrão
    dateTo: today    // Data de hoje como padrão
  });

  useEffect(() => {
    fetchLogs();
  }, [filters]);

  const fetchLogs = async () => {
    try {
      const params = new URLSearchParams();
      if (filters.actionType) params.append('action_type', filters.actionType);
      if (filters.dateFrom) params.append('date_from', filters.dateFrom);
      if (filters.dateTo) params.append('date_to', filters.dateTo);

      const response = await api.get(`/audit-logs?${params.toString()}`);
      setLogs(response.data);
    } catch (error) {
      console.error('Error fetching logs:', error);
    }
  };

  const formatActionType = (type) => {
    const types = {
      create: 'Criação',
      update: 'Atualização',
      delete: 'Remoção',
      login: 'Login',
      logout: 'Logout'
    };
    return types[type] || type;
  };

  return (
    <div className="container mt-4">
      <h2>Logs de Auditoria</h2>

      <div className="card mb-4">
        <div className="card-body">
          <h5 className="card-title">Filtros</h5>
          <div className="row">
            <div className="col-md-4">
              <label className="form-label">Tipo de Ação</label>
              <select
                className="form-select"
                value={filters.actionType}
                onChange={(e) => setFilters({ ...filters, actionType: e.target.value })}
              >
                <option value="">Todos</option>
                <option value="create">Criação</option>
                <option value="update">Atualização</option>
                <option value="delete">Remoção</option>
              </select>
            </div>
            <div className="col-md-4">
              <label className="form-label">Data Inicial</label>
              <input
                type="date"
                className="form-control"
                value={filters.dateFrom}
                onChange={(e) => setFilters({ ...filters, dateFrom: e.target.value })}
              />
            </div>
            <div className="col-md-4">
              <label className="form-label">Data Final</label>
              <input
                type="date"
                className="form-control"
                value={filters.dateTo}
                onChange={(e) => setFilters({ ...filters, dateTo: e.target.value })}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="table-responsive">
        <table className="table table-striped">
          <thead>
            <tr>
              <th>Data/Hora</th>
              <th>Usuário</th>
              <th>Ação</th>
              <th>Tabela</th>
              <th>ID Registro</th>
              <th>Detalhes</th>
            </tr>
          </thead>
          <tbody>
            {logs.map(log => (
              <tr key={log.id}>
                <td>{new Date(log.created_at).toLocaleString()}</td>
                <td>
                  {log.user_name ? (
                    <div>
                      <strong>{log.user_name}</strong>
                      <br />
                      <small className="text-muted">@{log.user_username}</small>
                    </div>
                  ) : (
                    <span className="badge bg-secondary">Sistema</span>
                  )}
                </td>
                <td>{formatActionType(log.action_type)}</td>
                <td>{log.table_name || '-'}</td>
                <td>{log.record_id || '-'}</td>
                <td>
                  <button
                    className="btn btn-sm btn-info"
                    data-bs-toggle="modal"
                    data-bs-target={`#logDetailsModal${log.id}`}
                  >
                    Ver
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Modais para detalhes */}
      {logs.map(log => (
        <div key={`modal-${log.id}`} className="modal fade" id={`logDetailsModal${log.id}`} tabIndex="-1">
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Detalhes do Log</h5>
                <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-md-6">
                    <h6>Valor Anterior</h6>
                    <pre>{JSON.stringify(log.old_value, null, 2)}</pre>
                  </div>
                  <div className="col-md-6">
                    <h6>Novo Valor</h6>
                    <pre>{JSON.stringify(log.new_value, null, 2)}</pre>
                  </div>
                </div>
                <div className="mt-3">
                  <h6>Metadados</h6>
                  <p><strong>IP:</strong> {log.ip_address || 'N/A'}</p>
                  <p><strong>User Agent:</strong> {log.user_agent || 'N/A'}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
